const store = {
  namespaced: true,
  state: {
    title : "TCY Archive",
    tagline : "Keep track of the best pieces",
    email: "love@fabricatorz.com",
    email_question : 'TCY: How are you?',
  }
}

export default store
